export const BUZZ_MENU_ITEMS = {
  FAVORITES: 'favorites',
  PEOPLE: 'people',
  DATA: 'data',
};
